const consentPreferenceType = Object.freeze({
  0: 'SubscriptionPreference_Type_Marketing',
  1: 'SubscriptionPreference_Type_Legitimate_Interest'
})

export { consentPreferenceType }



// WEBPACK FOOTER //
// ./src/modules/consent-manager/enum/ConsentPreferenceEnums.js